import * as React from "react";
import { DeviceContext } from "@/contexts/DeviceContext";

export function useDevice() {
  const context = React.useContext(DeviceContext);
  
  if (!context) {
    throw new Error('useDevice must be used within DeviceProvider');
  }
  
  return context;
}
